<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="100px">
      <el-form-item label="类型">
        <el-radio-group v-model="page_h5_type" :disabled="type==2">
          <el-radio-button :label="1">标题</el-radio-button>
          <el-radio-button :label="2">图片</el-radio-button>
          <el-radio-button :label="3">落地页文本</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="page_h5_type == 1" label="标题">
        <div style="max-height: 300px; overflow-y: auto;">
          <div
            v-for="(item, index) in titles"
            :key="index"
            style="display: flex; align-items: center; margin-bottom: 8px;"
          >
            <el-input v-model="titles[index]" placeholder="请输入标题" class="wajwqr" style="flex: 1;" />
            <el-button v-if="index == 0 && type!=2" icon="el-icon-plus" type="primary" style="margin-left: 5px;" circle @click="addTitle" />
            <el-button
              v-if="titles.length > 1 && type!=2"
              icon="el-icon-minus"
              type="danger"
              style="margin-left: 5px;"
              circle
              @click="removeTitle(index)"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="page_h5_type == 2" label="上传图片">
        <div v-if="updatalist.length > 0" style="display:flex;flex-wrap:wrap;gap:10px;">
          <div
            v-for="(item, index) in updatalist"
            :key="index"
            style="position: relative; width: 100px; height: 100px;"
          >
            <el-image :src="config.domain + item" fit="cover" style="width: 100%; height: 100%; border-radius: 4px;" />
            <!-- × 按钮 -->
            <span
              style="position: absolute;top: 2px;right: 2px;background: rgba(0,0,0,0.5);color: white;border-radius: 50%;width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;cursor: pointer;font-size: 14px;"
              @click="deleteImage(index)"
            >×</span>
          </div>
        </div>

        <el-upload
          v-if="type == 1"
          ref="upload"
          class="upload-demo"
          action="#"
          :http-request="httpRequest"
          :multiple="true"
          :show-file-list="false"
          :limit="100"
        >
          <el-button size="small" type="primary" icon="el-icon-upload">
            上传图片
          </el-button>
        </el-upload>
        <el-upload
          v-if="type == 2"
          ref="upload"
          class="upload-demo"
          action="#"
          :http-request="httpRequestrrr"
          :multiple="true"
          :show-file-list="false"
          :limit="100"
        >
          <el-button size="small" type="primary" icon="el-icon-upload">
            上传图片
          </el-button>
        </el-upload>
      </el-form-item>
      <!-- <el-input v-model="textarea" type="textarea" :rows="8" placeholder="请输入内容" class="my-textarea" /> -->
      <el-form-item v-if="page_h5_type == 3" label="落地页文本">
        <div style="max-height: 300px; overflow-y: auto;">
          <div
            v-for="(item, index) in textareas"
            :key="index"
            style="display: flex; align-items: flex-start; margin-bottom: 8px;"
          >
            <el-input
              v-model="textareas[index]"
              type="textarea"
              :rows="8"
              placeholder="请输入内容"
              class="my-textarea"
              style="flex: 1;"
            />
            <el-button v-if="index == 0 && type!=2" icon="el-icon-plus" type="primary" style="margin-left: 5px;" circle @click="addTextarea" />
            <el-button
              v-if="textareas.length > 1 && type!=2"
              icon="el-icon-minus"
              type="danger"
              style="margin-left: 5px;"
              circle
              @click="removeTextarea(index)"
            />
          </div>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="sumbitre">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getQcConfig } from '@/api/baiduAD.js'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'
import { addPweqweq, PageH5update } from '@/api/publicPlan.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      type: 1,
      title: '',
      textarea: '',
      updatalist: [],
      config: {},
      page_h5_type: 1,
      id: null,
      titles: [''],
      textareas: [''],
      obj: {}
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type, item) {
      this.type = type
      if (this.type === 2) {
        // this.title = item.title
        // this.updatalist = item.imgs
        // this.textarea = item.content
        // eslint-disable-next-line eqeqeq
        // if (item.page_h5_type == 1) {
        //   this.titles = []
        //   this.titles = [item.title]
        // }
        // // eslint-disable-next-line eqeqeq
        // if (item.page_h5_type == 2) {
        //   this.updatalist = []
        //   this.updatalist = item.imgs
        // }
        // // eslint-disable-next-line eqeqeq
        // if (item.page_h5_type == 3) {
        //   this.textareas = []
        //   this.textareas = [item.content]
        // }
        this.titles = []
        this.titles = [item.title]
        this.updatalist = []
        this.updatalist = item.imgs
        this.textareas = []
        this.textareas = [item.content]
        this.page_h5_type = item.page_h5_type
        this.id = item.id
      }
      this.getconfig()
    },
    async httpRequest(e) {
      // console.log('e:', e)
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const img = new Image()
      // const videoWidth = 0
      // const videoHeight = 0
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        // const temporary = e.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // temporary !== '多张' && (img.src = temporary)
        // this.temporary = temporary
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options, this.config.domain)
            this.updatalist.push(res.files[0].options.Key)
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    },
    async httpRequestrrr(e) {
      // console.log('e:', e)
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const img = new Image()
      // const videoWidth = 0
      // const videoHeight = 0
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        // const temporary = e.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // temporary !== '多张' && (img.src = temporary)
        // this.temporary = temporary
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options, this.config.domain)
            console.log(' this.updatalist', this.updatalist[0])
            this.updatalist = []
            this.updatalist = [res.files[0].options.Key]
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    },

    async getconfig() {
      const res = await getQcConfig()
      this.config = res.data.qcconfig
    },
    deleteImage(index) {
      this.updatalist.splice(index, 1)
    },
    sumbitre() {
      console.log(this.titles, this.textareas)
      //   if (this.page_h5_type === 1) {
      //     if (
      //       this.titles.length === 0 ||
      //       this.titles.some(title => title.trim() === '')
      //     ) {
      //       this.$message.error('请输入完整的标题')
      //       return
      //     }
      //   }
      //   if (this.page_h5_type === 2) {
      //     if (this.updatalist.length === 0) {
      //       this.$message.error('请上传图片')
      //       return
      //     }
      //   }
      //   if (this.page_h5_type === 3) {
      //     if (
      //       this.textareas.length === 0 ||
      // this.textareas.some(text => text.trim() === '')
      //     ) {
      //       this.$message.error('请输入完整的落地页文本')
      //       return
      //     }
      //   }
      const { titles, updatalist, textareas } = this

      const hasValidTitle = titles.some(item => item && item.toString().trim() !== '')
      const hasValidUpdate = updatalist.some(item => item && item.toString().trim() !== '')
      const hasValidTextarea = textareas.some(item => item && item.toString().trim() !== '')

      if (!hasValidTitle && !hasValidUpdate && !hasValidTextarea) {
        this.$message.error('必须选择一项标题/上传图片/落地页文本')
        return
      }

      if (this.type === 1) {
        // if (this.page_h5_type === 1) {
        //   this.obj = {}
        //   this.obj.titles = this.titles
        // }
        // if (this.page_h5_type === 2) {
        //   this.obj = {}
        //   this.obj.imgs = this.updatalist
        // }
        // if (this.page_h5_type === 3) {
        //   this.obj = {}
        //   this.obj.contents = this.textareas
        // }
        const titles = this.titles.some(item => item && item.toString().trim() !== '')
          ? this.titles
          : []
        const textareas = this.textareas.some(item => item && item.toString().trim() !== '')
          ? this.textareas
          : []
        addPweqweq({
          // ...this.obj,
          titles: titles,
          imgs: this.updatalist,
          contents: textareas
          // page_h5_type: this.page_h5_type
        }).then((res) => {
          this.$message.success('创建成功')
          this.$emit('updata')
          console.log('res', res)
        })
      } else {
        // if (this.page_h5_type === 1) {
        //   this.obj = {}
        //   this.obj.titles = this.titles
        // }
        // if (this.page_h5_type === 2) {
        //   this.obj = {}
        //   this.obj.imgs = this.updatalist
        // }
        // if (this.page_h5_type === 3) {
        //   this.obj = {}
        //   this.obj.contents = this.textareas
        // }
        const titles = this.titles.some(item => item && item.toString().trim() !== '')
          ? this.titles
          : []
        const textareas = this.textareas.some(item => item && item.toString().trim() !== '')
          ? this.textareas
          : []
        PageH5update({
          // ...this.obj,
          titles: titles,
          imgs: this.updatalist,
          contents: textareas,
          id: this.id
        }).then((res) => {
          this.$message.success('修改成功')
          this.$emit('updata')
          console.log('res', res)
        })
      }
    },
    validateFields() {
      const { titles, updatalist, textareas } = this

      const hasValidTitle = titles.some(item => item && item.toString().trim() !== '')
      const hasValidUpdate = updatalist.some(item => item && item.toString().trim() !== '')
      const hasValidTextarea = textareas.some(item => item && item.toString().trim() !== '')

      if (!hasValidTitle || !hasValidUpdate || !hasValidTextarea) {
        this.$message.error('titles、updatalist、textareas 三者必须各至少有一项不为空')
        return false
      }

      return true
    },
    addTitle() {
      this.titles.push('')
    },
    removeTitle(index) {
      if (this.titles.length > 1) {
        this.titles.splice(index, 1)
      }
    },
    addTextarea() {
      this.textareas.push('')
    },
    removeTextarea(index) {
      if (this.textareas.length > 1) {
        this.textareas.splice(index, 1)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.wajwqr {
  width: 500px;
}

.my-textarea .el-textarea__inner {
  height: 150px !important;
}

.upload-demo {
  margin-top: 10px;
}
</style>
